import { useMsal } from "@azure/msal-react";
import { loginScopes } from "../auth/msalConfig";

export default function LoginScreen() {
  const { instance } = useMsal();

  const signIn = () => {
    instance.loginRedirect({ scopes: loginScopes });
  };

  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", height: "100vh", gap: 16, textAlign: "center",
    }}>
      <img
        src="/onecleanspace-logo.png"
        alt="OneCleanSpace"
        style={{ width: 600, maxWidth: "80vw" }}
      />
      <div style={{ fontSize: 14, color: "var(--text2)", maxWidth: 320, lineHeight: 1.6 }}>
        Sign in with your CleanSpace Microsoft account to get started.
      </div>
      <button
        onClick={signIn}
        style={{
          marginTop: 8, padding: "10px 24px",
          background: "var(--cs-navy)", color: "#fff",
          border: "none", borderRadius: "var(--radius)",
          fontSize: 14, fontWeight: 500, cursor: "pointer",
          display: "flex", alignItems: "center", gap: 8,
        }}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect width="7.5" height="7.5" fill="#F35325"/>
          <rect x="8.5" width="7.5" height="7.5" fill="#81BC06"/>
          <rect y="8.5" width="7.5" height="7.5" fill="#05A6F0"/>
          <rect x="8.5" y="8.5" width="7.5" height="7.5" fill="#FFBA08"/>
        </svg>
        Sign in with Microsoft
      </button>
    </div>
  );
}
